import { userIsCustomer, userIsLoggedIn } from "~/utils/roles";
import { setUpLoginPopUp, toBeRedirectedToPdp } from "~/utils/redirectionUtil";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import { useState } from "react";
import SignOutFromPlusPopUp from "~/Login/components/SignoutFromPlusPopUp";
import MediasBusinessLoginPopup from "~/Login/components/MediasBusinessLoginPopup";
import ResetPasswordPopup from "~/Login/components/ResetPasswordPopup";

const RedirectToPDPComponent = () => {
  const { val: loginPopupOpen, setFalse: closeLogin } = useBooleanState(true);
  const { val: resetPopupOpen, setTrue: openReset, setFalse: closeReset } = useBooleanState(false);
  const [email, setEmail] = useState("");

  const loggedIn = userIsLoggedIn();
  const suggestUserSwitch = !!window.SCHA.redirect?.suggestUserSwitch;
  if (suggestUserSwitch) {
    setUpLoginPopUp();
  }
  const showLogoutPopup = loggedIn && !userIsCustomer() && suggestUserSwitch;
  const showBusinessLoginPopup = !loggedIn && toBeRedirectedToPdp();

  const onResetClick = (email: string) => {
    setEmail(email);
    closeLogin();
    openReset();
  };

  return (
    <>
      {showLogoutPopup && <SignOutFromPlusPopUp />}
      {loginPopupOpen && showBusinessLoginPopup && (
        <MediasBusinessLoginPopup initialEmail={""} onResetClick={onResetClick} />
      )}
      {resetPopupOpen && <ResetPasswordPopup initialEmail={email} close={closeReset} />}
    </>
  );
};
export default RedirectToPDPComponent;
